import React, {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import Styles from './index.module.scss'
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import Service from "../service"

/**
 * @description 申请详情页面
 * @return {/culturalExchange_greencarbon/applyDetail}
 */

const ApplyDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [recordData, setRecordData] = useState(null);

  useEffect(() => {
    // 从路由 state 中获取传递的数据
    if (location.state && location.state.recordData) {
      setRecordData(location.state.recordData);
    } else {
      // 如果没有传递数据，可以尝试从 URL 参数获取 ID 然后调用接口
      // 或者返回上一页
      Toast.show('数据加载失败');
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    }
    getData(location.state.recordData?.id);
  }, [location]);

  const getData = async (id) => {
    const res = await Service.getApprovalDetail(id);
    console.log('res===>', res)
    setRecordData(res.data);
  }

  const handleBack = () => {
    navigate(-1);
  }

  if (!recordData) {
    return (
      <div className={Styles.applyDetail}>
        <div className={Styles.statusBar}></div>
        <div className={Styles.navBar}>
          <div className={Styles.backButton} onClick={handleBack}></div>
          <div className={Styles.title}>申请详情</div>
          <div className={Styles.placeholder}></div>
        </div>
        <div className={Styles.loading}>加载中...</div>
      </div>
    );
  }

  const status = recordData.status || 0;
  const isApproved = status === 1;

  return (
    <div className={Styles.applyDetail}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}></div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}></div>
        <div className={Styles.title}>详情</div>
        <div className={Styles.placeholder}></div>
      </div>

      {/* 内容区域 */}
      <div className={Styles.content}>
        {/* 第一个卡片：绿交所账户和数量 */}
        <div className={Styles.detailCard}>
          <div className={Styles.infoRow}>
            <span className={`${Styles.label} ${Styles.grayLabel}`}>绿交所账户</span>
            <span className={`${Styles.value} ${Styles.blackValue}`}>{recordData.account || ''}</span>
          </div>
          <div className={Styles.divider}></div>
          <div className={Styles.infoRow}>
            <span className={`${Styles.label} ${Styles.grayLabel}`}>数量</span>
            <span className={`${Styles.value} ${Styles.blackValue}`}>{recordData.num || '0'}</span>
          </div>
        </div>

        {/* 第二个卡片：手续费和总计 */}
        <div className={Styles.detailCard}>
          <div className={Styles.infoRow}>
            <span className={`${Styles.label} ${Styles.darkLabel}`}>手续费</span>
            <span className={`${Styles.value} ${Styles.darkValue} ${Styles.rightAlign}`}>¥{recordData.fees || '0.00'}{recordData.usePoint>0?'及'+recordData.usePoint+'积分':''}</span>
          </div>
          <div className={Styles.divider}></div>
          <div className={Styles.infoRow}>
            <span className={`${Styles.label} ${Styles.darkLabel}`}>总计:</span>
            <span className={`${Styles.value} ${Styles.darkValue} ${Styles.rightAlign}`}>¥{recordData.totalFees || '0.00'}</span>
          </div>
        </div>

        {/* 第三个卡片：提交时间（和通过时间） */}
        <div className={Styles.detailCard}>
          <div className={Styles.infoRow}>
            <span className={`${Styles.label} ${Styles.darkLabel}`}>提交时间</span>
            <span className={`${Styles.value} ${Styles.darkValue} ${Styles.rightAlign}`}>{recordData.createTime || ''}</span>
          </div>
          {/* 已通过状态显示通过时间 */}
          {isApproved && recordData.optTime && (
            <>
              <div className={Styles.divider}></div>
              <div className={Styles.infoRow}>
                <span className={`${Styles.label} ${Styles.darkLabel}`}>通过时间</span>
                <span className={`${Styles.value} ${Styles.darkValue} ${Styles.rightAlign}`}>{recordData.optTime}</span>
              </div>
            </>
          )}
        </div>
        
        {/* 提示信息 */}
        <div className={Styles.tipText}>
          {isApproved ? (
            <>我们将在10个工作日内完成转移,且<span className={Styles.highlightText}>藏品将被回收</span></>
          ) : (
            <>通过后我们将在10个工作日内完成转移,且<span className={Styles.highlightText}>藏品将被回收</span></>
          )}
        </div>
        
        {/* 状态按钮 */}
        <div className={`${Styles.statusBtn} ${isApproved ? Styles.approvedBtn : Styles.reviewingBtn}`}>
          {status === 1 ? '已通过' : status === 2 ?'审核拒绝':'审核中'}
        </div>
      </div>
    </div>
  )
}

export default ApplyDetail
